export default __webpack_public_path__ + "assets/file-cog-outline.3e6bce71.webp";